/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CountryData
 */
export interface CountryData {
    /**
     * 
     * @type {string}
     * @memberof CountryData
     */
    countryName?: string;
    /**
     * 
     * @type {number}
     * @memberof CountryData
     */
    amount?: number;
}

/**
 * Check if a given object implements the CountryData interface.
 */
export function instanceOfCountryData(value: object): value is CountryData {
    return true;
}

export function CountryDataFromJSON(json: any): CountryData {
    return CountryDataFromJSONTyped(json, false);
}

export function CountryDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CountryData {
    if (json == null) {
        return json;
    }
    return {
        
        'countryName': json['countryName'] == null ? undefined : json['countryName'],
        'amount': json['amount'] == null ? undefined : json['amount'],
    };
}

export function CountryDataToJSON(json: any): CountryData {
    return CountryDataToJSONTyped(json, false);
}

export function CountryDataToJSONTyped(value?: CountryData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'countryName': value['countryName'],
        'amount': value['amount'],
    };
}

